import React, { Component } from 'react';
import ReactTable from 'react-table'
import withTitle from '../components/withTitle';
import './KeyFiguresTable.css';
import 'react-table/react-table.css';

/**
 * Generic table for displaying small amounts of data.
 * Note that no formatting is applied to the values.
 * You must apply any formatting to the values beforehand.
 */
class KeyFiguresTable extends Component {
  render() {
    const columns = [
      {
        Header: 'Number',
        accessor: 'id',
        minWidth: 40,
      }, {
        Header: 'Value',
        accessor: 'value',
        minWidth: 20,
        Cell: props => <div className="value">{props.value}</div>
      },
    ];

    return (
      <div style={{ width: '100%', overflow: 'auto' }} >
        {Object.entries(this.props.data).map(([key, value]) => (
          <div key={key}>
            {key !== null ? <h3 className="key-figures-table-header">{key}</h3> : null}
            <ReactTable
              className="key-figures-table -striped -highlight"
              data={value}
              columns={columns}
              showPagination={false}
              defaultPageSize={5}
              pageSize={value.length}
              sortable={false}
              headerStyle={{ display: 'none' }}
            />
          </div>
        ))}
      </div>
    );
  }
}

export default withTitle(KeyFiguresTable);


// WEBPACK FOOTER //
// ./src/charts/KeyFiguresTable.js